import { Route, Routes } from "react-router-dom"
import List from "./pages/List"
import ModalEditTemplate from "./pages/ModalEditTemplate"
export const Router = () => {
  return (
    <div>
      <Routes>
        <Route path="/*" element={<List />} />
        <Route path="/:id" element={<ModalEditTemplate />} />
      </Routes>
    </div>
  )
}
